module.exports = __webpack_public_path__ + "img/dsci0009.d35be139.jpg";